import { EmailApi } from '@/Api/Email/EmailApi';
import { GetEmailPreviewForOrderResponse } from '@/Api/Email/GetEmailPreviewForOrderResponse';
import { SendEmailForOrderRequest, SendEmailForOrdersRequest } from '@/Api/Email/SendEmailForOrdersRequest';
import { SendFormattedEmailForOrderRequest } from '@/Api/Email/SendFormattedEmailForOrderRequest';
import { LocalizationType } from '@/Enums';
import { TranslationType } from '@/Localization/LanguageKeys';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { DocumentTemplateApi } from '@/Api/DocumentTemplates/DocumentTemplatesApi';
import { DocumentTemplateType } from '@/Enums/DocumentTemplateType';
import { DocumentTemplatePrintType } from '@/Models';
import { GetDocumentsInfoResponse } from '@/Api/_Microservices/OnlineArchive/Documents/GetDocumentsInfoResponse';
import { GetDocumentsInfoRequest } from '@/Api/_Microservices/OnlineArchive/Documents/GetDocumentsInfoRequest';
import { DocumentsApi } from '@/Api/_Microservices/OnlineArchive/Documents';
import { RootState } from '@/Redux/RootReducer';
import { emailSendModalSelectors } from '@/ModalWindows/EmailSendModal/services/selectors';

const sendEmailForOrders = createAsyncThunk(
  'emailSendModalSlice/send-email-for-orders',
  async (request: SendEmailForOrdersRequest, thunkApi) => {
    const result = await EmailApi.sendEmailForOrders(request);

    const { global } = thunkApi.getState() as any;

    return {
      result: result,
      translation: global.translation as TranslationType,
      localization: global.localization as LocalizationType,
    };
  },
);

const sendEmailForOrder = createAsyncThunk(
  'emailSendModalSlice/send-email-for-order',
  async (request: SendEmailForOrderRequest, thunkApi) => {
    const result = await EmailApi.sendEmailForOrder(request);

    const { global } = thunkApi.getState() as any;

    return {
      result: result,
      translation: global.translation as TranslationType,
      localization: global.localization as LocalizationType,
    };
  },
);

const sendFormattedEmailForOrder = createAsyncThunk(
  'emailSendModalSlice/send -formatted-email-for-order',
  async (request: SendFormattedEmailForOrderRequest, thunkApi) => {
    const result = await EmailApi.sendFormatterEmailForOrder(request);

    const { global } = thunkApi.getState() as any;

    return {
      result,
      translation: global.translation as TranslationType,
      localization: global.localization as LocalizationType,
    };
  },
);

const getEmailPreviewForOrder = createAsyncThunk<
  GetEmailPreviewForOrderResponse,
  { templateGuid: string; orderId: number }
>('emailSendModalSlice/get-email-preview-for-order', async (request, thunkApi) => {
  const state = thunkApi.getState() as RootState;
  const numbers: string[] = emailSendModalSelectors.selectedNumbers(state);

  return EmailApi.getEmailPreviewForOrder({
    ...request,
    numbers,
  });
});

const getEmailTemplates = createAsyncThunk(
  'emailSendModalSlice/get-email-templates',
  async (documentType: DocumentTemplatePrintType) => {
    return DocumentTemplateApi.getAllDocumentTemplates(DocumentTemplateType.Email, documentType);
  },
);

const getDocumentsForEmail = createAsyncThunk<GetDocumentsInfoResponse, GetDocumentsInfoRequest>(
  'emailSendModalSlice/get-documents-for-email',
  async (request) => {
    return DocumentsApi.getDocumentsInfo(request);
  },
);

export const asyncActions = {
  sendEmailForOrders,
  sendEmailForOrder,
  sendFormattedEmailForOrder,
  getEmailPreviewForOrder,
  getEmailTemplates,
  getDocumentsForEmail,
};
